<template>
  <div
    v-if="tableState.showTable"
    class="positioner"
  >
    <power-table
      :row-data="tableState.dataTable"
      :header-props="headerProps()"
      :active="active"
      :is-training="isTraining"
      :is-start-list="tableState.isStartList"
      :show-discipline-icon="showDisciplineIcon"
      class="transform-origin-top-center"
      @mousedown="oneClick"
      @touchstart="oneClick"
    />
  </div>
</template>

<script lang="ts">
import {
  requestManager,
  modes,
  trainingManager,
  playersManager,
  timeManager
} from '@powerplay/core-minigames'
import { PowerTable } from '@powerplay/core-minigames-ui'
import { defineComponent } from 'vue'
import { pathAssets } from '@/globals/globalvariables'
import {
  type TableState,
  tableState
} from '@/stores/index'

export default defineComponent({
  name: 'DataTable',
  components: {
    PowerTable
  },
  data() {

    return {
      active: false,
      firstClick: false,
      /*
       * headerProps: {
       *  // time: '3:12:05',
       *  discipline: {
       *      name: 'Downhill',
       *      image: `${pathAssets}/ui/table/ICO-DISCIPLINE.png`
       *  },
       *  // competitonType: 'Test hill'
       *  resultType: this.$t('')
       *  // add: {
       *  //     image: `${pathAssets}/ui/table/Logo-Default.png`,
       *  //     alt: 'Add-logo'
       *  // }
       * }
       */
      tableState: tableState()
    }

  },
  computed: {
    isTraining() {

      return modes.isTrainingMode()

    },
    showDisciplineIcon() {

      return modes.isBossCompetition()

    }
  },
  watch: {
    tableState: {
      handler(value: TableState) {

        setTimeout(() => {


          this.active = value.activeState

        }, 10)


      },
      deep: true
    }
  },
  methods: {
    oneClick(event: Event) {

      if (tableState().activeState) event.stopPropagation()

    },
    headerProps() {

      let time = ''
      if (this.isTraining) {

        time = trainingManager.bestScore.toString()

      } else if (modes.isTournament()) {

        time = ''

      } else {

        time = timeManager.getTimeInFormatFromSeconds(
          playersManager.getPlayer().personalBest,
          3
        )

      }

      return {
        discipline: {
          name: this.$t(`disciplineName${requestManager.disciplineID}`),
          image: `${pathAssets}/ui/table/ICO-DISCIPLINE.png`
        },
        time,
        competitonType: this.$t(tableState().competitionText),
        resultType: this.$t(tableState().resultText),
        headerTableText: {
          // col2: 'asdf'
        }
      }

    }
  }
})
</script>

<style scoped lang="less">
.positioner {
  position: absolute;
  top: 13%;
  left: 50%;
  transform: translateX(-50%);

  .transform-origin-top-center {
    transform-origin: top center;
  }
}
</style>
